export enum Cultures {
  EnUs = "en-US",
  EnCa = "en-CA",
  FrCa = "fr-CA",
  CaEs = "ca-ES",
  CsCz = "cs-CZ",
  EsEs = "es-ES",
  EsMx = "es-MX",
  EnGb = "en-GB",
  DeDe = "de-DE",
  DeAt = "de-AT"
}
